import { render, staticRenderFns } from "./HygicultOwner.vue?vue&type=template&id=07f929dd&"
import script from "./HygicultOwner.vue?vue&type=script&lang=js&"
export * from "./HygicultOwner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports